import { ListMenuItem } from 'components/styles_components/menu';
import { ListItemText } from 'components/ui';
import { ProbelistLogoutIcon } from 'components/uiIcons';
import { FormattedMessage } from 'react-intl';
import { removeAuthenticated } from 'utils/authentication';
import LogoutMutation from 'mutations/user/logout';
import useResourceMutation from 'hooks/use_resource_mutation';

const LogoutButton = () => {
  const [logout, { loading }] = useResourceMutation(LogoutMutation, {
    onCompleted: () => removeAuthenticated(),
    errorKey: 'error.user.logout',
  });

  return (
    <ListMenuItem onClick={logout} disabled={loading}>
      <ProbelistLogoutIcon aria-hidden="true" />
      <ListItemText>
        <FormattedMessage id="navbar.logout" />
      </ListItemText>
    </ListMenuItem>
  );
};

export default LogoutButton;
